import { TabContent, TabPane } from 'reactstrap';
import { UniversalTrackerModalTab } from '@g17eco/types/universalTrackerModal';

interface Props {
  tabs: UniversalTrackerModalTab[];
  activeTab: UniversalTrackerModalTab['navId'];
}

export const ContentTabs = ({ tabs, activeTab }: Props) => {
  return (
    <div className='px-sm mt-1'>
      <TabContent activeTab={activeTab}>
        {tabs.map((btn, i) => (
          <TabPane key={i} tabId={btn.navId}>
            {activeTab === btn.navId ? btn.component : null}
          </TabPane>
        ))}
      </TabContent>
    </div>
  );
};
